export enum HomeWeekChartSegment {
  OVERALL = 'overall',
  MORNING = 'morning',
  EVENING = 'evening',
  FOCUS = 'focus'
}

export enum HomeWeekChartValueUnit {
  PERCENT = 'percent',
  COUNT = 'count'
}
